import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
// Actions 
import {
  reportsMainGenerateReportProgress
} from 'Redux/actions'; 

import {
  getTimeZone
} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getJBDiagnosticDetailsReport(report, event) {
  const { timeZone, name, reportTimeRanges } = report;
  const { startRange, endRange } = report.filters;
  const {
    filterType,
    filterArray,
    page,
    rowsPerPage,
    sortField,
    sortOrder,
    otherFilters
  } = event.filters;
  try {
      const newReport = JSON.parse(JSON.stringify(report))
      let data = yield call(
        clientQuery,
        `query getJBDiagnosticDetailsReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
          getJBDiagnosticDetailsReport (conditions: $conditions, limit: $limit, offset: $offset) {
              items {
                unitTime
                eventName
                acceleratorPedalPosition
                batteryVoltage
                brakePedalPosition
                engineCoolantLevel
                engineCoolantPressure
                engineCoolantTemp
                engineFuelRate
                engineOilLevel
                engineOilPressure
                engineOilTemp
                fuelLevelOne
                fuelLevelTwo
                odometer
                rpm
                seatbeltswitch
              }
              total
              limit
              offset
              category
          }
      }`,
        {
          "conditions": {
            reportName: name,
            "category": {
              field: filterType,
              value: filterArray?.id
            },
            timeZone: getTimeZone(timeZone),
            dateRange: {
              fields: [
                "unitTime"
              ],
              GTE: startRange,
              LTE: endRange,
              reportTimeRanges
            },
            sortField: {
              field: sortField || "deviceId",
              order: sortOrder === 'desc' ? 'DESC' : 'ASC'
            }
          },
          limit: rowsPerPage,
          offset: page
        },
        endpoints.GRAPHQL_PX_REPORTING
      );
      
      if (data?.getJBDiagnosticDetailsReport) {
        newReport.summary = data.getJBDiagnosticDetailsReport
        newReport.loadingSummary = false
        yield put(reportsMainGenerateReportProgress(newReport))
      } else {
        newReport.loadingSummary = false
        yield put(reportsMainGenerateReportProgress(newReport))
      }
    } catch (exc) {
      report.loadingSummary = false
      ExceptionManager(exc, 'src/modules/reports/views/main/components/reportsTab/.components/reports/stopReport', 'getJBDiagnosticDetailsReport');
      yield put(reportsMainGenerateReportProgress(report))
    }
  }


export default getJBDiagnosticDetailsReport;